import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import qs from 'qs';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Input
} from '@material-ui/core';

const Filter = ({ handleChange, filters }) => {
  const { search } = useHistory();
  return (
    <FormControl style={{ margin: '5px 0px 5px 50px', width: '20%' }}>
      <InputLabel htmlFor="select-multiple-checkbox">
        État des commandes
      </InputLabel>
      <Select
        multiple
        style={{ width: 220 }}
        value={qs.parse(search, { ignoreQueryPrefix: true }).states || []}
        onChange={handleChange}
        input={<Input id="select-multiple-checkbox" />}
        renderValue={selected =>
          selected
            .map(item => filters.find(element => element.value === item).label)
            .join(', ')
        }
      >
        {filters
          .filter(h => !h.hidden)
          .map(item => (
            <MenuItem key={item.label} value={item.value}>
              <Checkbox
                checked={
                  qs.parse(search, { ignoreQueryPrefix: true }).states
                    ? qs
                        .parse(search, { ignoreQueryPrefix: true })
                        .states.indexOf(item.value) > -1
                    : false
                }
              />
              <ListItemText primary={item.label} />
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

Filter.propTypes = {
  filters: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default Filter;
